import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { getCurrentInstance, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MSelectItem',
  props: {
    active: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const selectMenuEntry = ref<HTMLElement | null>(null);

/* const props = */ 


const instance = getCurrentInstance();

const onClick = () => {
  if (instance && instance.parent && instance.parent.exposed && instance.parent.exposed.hide) instance.parent.exposed.hide();
  emit("click");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: onClick,
    class: _normalizeClass(["select-menu-entry", { active: _ctx.active }]),
    ref_key: "selectMenuEntry",
    ref: selectMenuEntry
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})